import {
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    Table,
    TableBody
} from '@material-ui/core';
import formatters from '../../../Core/Grid/inputFormatter';

const summaryHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "totalStock",
        label: "Total Stock",
        classLabel: "columnSize80"
    },
    {
        label: "Stock Turn",
        id: "stockTurn",
        classLabel: "columnSize80"
    },
    {
        label: "DIS",
        id: "dis",
        classLabel: "columnSize80"
    },
    {
        id: "overaged90",
        label: "Overaged(90+)",
        classLabel: "columnSize80"
    },
    {
        id: "advertisedStock",
        label: "Advertised Stock",
        classLabel: "columnSize80"
    },
    {
        id: "reserved",
        label: "Reserved",
        classLabel: "columnSize80"
    },
    {
        id: "totalActions",
        label: "Total Actions",
        classLabel: "columnSize80"
    },
    {
        id: "totalStockValue",
        label: "Total Stock Value",
        classLabel: "columnSize80"
    },
    {
        id: "avgSiv",
        label: "Avg.SIV",
        classLabel: "columnSize80"
    },
    {
        id: "totalWritedown",
        label: "Total Writedown",
        classLabel: "columnSize80"
    },
];

const profileHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "totalStock",
        label: "Total Stock",
        classLabel: "columnSize80"
    },
    {
        id: "retail",
        label: "Retail",
        classLabel: "columnSize80"
    },
    {
        id: "preReg",
        label: "Pre-Reg",
        classLabel: "columnSize80"
    },
    {
        id: "demo",
        label: "Demo",
        classLabel: "columnSize80"
    },
    {
        id: "cBS",
        label: "CBS",
        classLabel: "columnSize80"
    },
    {
        id: "cMV",
        label: "CMV",
        classLabel: "columnSize80"
    },
    {
        id: "courtesyCar",
        label: "Courtesy Car",
        classLabel: "columnSize80"
    },
    {
        id: "lTHire",
        label: "LT Hire",
        classLabel: "columnSize80"
    },
    {
        id: "trade",
        label: "Trade",
        classLabel: "columnSize80"
    },
];

const ageDueInHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "age30",
        label: "0-30",
        classLabel: "columnSize80"
    },
    {
        id: "age3060",
        label: "31-60",
        classLabel: "columnSize80"
    },
    {
        id: "age6190",
        label: "61-90",
        classLabel: "columnSize80"
    },
    {
        id: "overaged90",
        label: "90+",
        classLabel: "columnSize80"
    },
    {
        id: "reserved",
        label: "Reserved",
        classLabel: "columnSize80"
    },
    {
        id: "dueIn7",
        label: "Due In (<7 Days)",
        classLabel: "columnSize80"
    },
    {
        id: "dueInEoM",
        label: "Due In (EoM)",
        classLabel: "columnSize80"
    },
    {
        id: "dueInLater",
        label: "Due In (Later)",
        classLabel: "columnSize80"
    },
];

const actionsHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "totalActions",
        label: "Total Actions",
        classLabel: "columnSize80"
    },
    {
        id: "noPrice",
        label: "No Price",
        classLabel: "columnSize80"
    },
    {
        id: "noPhotos",
        label: "No Photos",
        classLabel: "columnSize80"
    },
    {
        id: "toPrep",
        label: "To Prep",
        classLabel: "columnSize80"
    },
    {
        id: "priceChange",
        label: "Price Change",
        classLabel: "columnSize80"
    },
    {
        id: "reserved3Plus",
        label: "Reserved 3+ Days",
        classLabel: "columnSize80"
    },
];

const valueHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "totalStock",
        label: "Total Stock Value",
        classLabel: "columnSize80"
    },
    {
        id: "budget",
        label: "Stock Budget",
        classLabel: "columnSize80"
    },
    {
        id: "budgetPerc",
        label: "% Budget",
        classLabel: "columnSize80"
    },
    {
        id: "retailPreReg",
        label: "Retail & Pre Reg Units",
        classLabel: "columnSize80"
    },
    {
        id: "avgSiv",
        label: "Avg. SIV",
        classLabel: "columnSize80"
    },
    {
        id: "atTrade",
        label: "AT Trade",
        classLabel: "columnSize80"
    },
    {
        id: "atVariance",
        label: "AT Variance",
        classLabel: "columnSize80"
    },
    {
        id: "capClean",
        label: "CAP Clean",
        classLabel: "columnSize80"
    },
    {
        id: "capVariance",
        label: "CAP Variance",
        classLabel: "columnSize80"
    },
];

export const GroupComparisonSummaryTable = (props) => {
    const sites = props.sites;
    const type = props.type;

    return (
        <TableContainer className='groupComparisonTable'>
            <Table>
                <TableHead>
                    <TableRow>
                        {
                            type === "Summary" ? 
                                summaryHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            : 
                            type === "Profile" ? 
                                profileHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            : 
                            type === "Age" ? 
                                ageDueInHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            type === "Actions" ? 
                                actionsHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            type === "Value" ? 
                                valueHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            ""
                        }
                    </TableRow>
                </TableHead>
                <TableBody className='groupComparisonTableBody'>
                    { 
                        sites && sites.length > 0 && sites.sort((a, b) => {
                            if (a.site === "GROUP") return -1;
                            if (b.site === "GROUP") return 1;
                            return a.site.localeCompare(b.site);
                        }).map((row) => (
                            type === "Summary" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.totalStock}
                                    </TableCell>
                                    <TableCell >
                                        {row.stockTurn}
                                    </TableCell>
                                    <TableCell >
                                        {row.dis}
                                    </TableCell>
                                    <TableCell >
                                        {row.overaged90}
                                    </TableCell>
                                    <TableCell >
                                        {row.advertisedStock}
                                    </TableCell>
                                    <TableCell >
                                        {row.reserved}
                                    </TableCell>
                                    <TableCell >
                                        {row.totalActions}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.totalStockValue)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.avgSIV)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.totalWritedown)}
                                    </TableCell>
                                </TableRow> 
                            :
                            type === "Profile" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.totalStock}
                                    </TableCell>
                                    <TableCell >
                                        {row.retail}
                                    </TableCell>
                                    <TableCell >
                                        {row.preReg}
                                    </TableCell>
                                    <TableCell >
                                        {row.demo}
                                    </TableCell>
                                    <TableCell >
                                        {row.cbs}
                                    </TableCell>
                                    <TableCell >
                                        {row.cmv}
                                    </TableCell>
                                    <TableCell >
                                        {row.courtesyCar}
                                    </TableCell>
                                    <TableCell >
                                        {row.ltHire}
                                    </TableCell>
                                    <TableCell >
                                        {row.trade}
                                    </TableCell>
                                </TableRow> 
                            :
                            type === "Age" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.age030}
                                    </TableCell>
                                    <TableCell >
                                        {row.age3060}
                                    </TableCell>
                                    <TableCell >
                                        {row.age6190}
                                    </TableCell>
                                    <TableCell >
                                        {row.overaged90}
                                    </TableCell>
                                    <TableCell >
                                        {row.reserved}
                                    </TableCell>
                                    <TableCell >
                                        {row.dueIn7}
                                    </TableCell>
                                    <TableCell >
                                        {row.dueInEoM}
                                    </TableCell>
                                    <TableCell >
                                        {row.dueInLater}
                                    </TableCell>
                                </TableRow>
                            :
                            type === "Actions" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.totalActions}
                                    </TableCell>
                                    <TableCell >
                                        {row.noPrice}
                                    </TableCell>
                                    <TableCell >
                                        {row.noPhotos}
                                    </TableCell>
                                    <TableCell >
                                        {row.toPrep}
                                    </TableCell>
                                    <TableCell >
                                        {row.priceChange}
                                    </TableCell>
                                    <TableCell >
                                        {row.reserved3Plus}
                                    </TableCell>
                                </TableRow>
                            :
                            type === "Value" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.totalStockValue)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.MillionWithMWithoutZero(row.stockBudget)}
                                    </TableCell>
                                    <TableCell >
                                        {row.budgePerc}
                                    </TableCell>
                                    <TableCell >
                                        {row.retailPreReg}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.avgSIV)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.atTrade)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.atVariance)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.capClean)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.capVariance)}
                                    </TableCell>
                                </TableRow>
                            :
                            ""
                        )) 
                    }                     
                </TableBody>
            </Table>
        </TableContainer>
    );
}